import React from 'react'

import HtmlParser from 'react-html-parser';
import { globalSettings, languageObjGet, styles } from '../../helpers/settings';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'RegisterUserMessage';

export default function RegisterUserMessage({
    user = {
        firstName: '',
        lastName: '',
        email: '',
    },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region old code
    // let msgText = `Estimado <b>${user?.firstName} ${user?.lastName}</b>, por seguridad y para completar el proceso de registro debe ingresar a su cuenta de correo electrónico: `;
    // msgText += `<b>${user?.email}</b> y verifique su cuenta <b>(haciendo clic en el enlace que le enviamos)</b>, una vez que la cuenta esté verificada podrá `;
    // msgText += `acceder a nuestro sistema. Si no puede ver el correo en la <b>Bandeja de entrada</b>, verifique el buzón de <b>Spam</b> o <b>Correo no deseado</b>. `;
    // msgText += `Si no recibe el correo electrónico de confirmación, comuníquese con el `;
    // msgText += `<a href='mailto:${globalSettings?.app?.emails?.dptoSupport}?subject=${globalSettings?.labels?.registry?.[languageObj?.id]}%20${globalSettings?.labels?.new?.[languageObj?.id]}%20${globalSettings?.labels?.user?.[languageObj?.id]}%20(${globalSettings?.labels?.message?.[languageObj?.id]})'><b>${globalSettings?.labels?.supportDepartment?.[languageObj?.id]}</b></a>`;
    //#endregion old code
    let msgText = globalSettings?.messages?.registerNewUserMessages({
        firstName: user?.firstName,
        lastName: user?.lastName,
        email: user?.email,
        paragraph: 1,
        languageId: languageObj?.id,
    });

    return (
        <div className='error-page'>
            <h5><i className='fas fa-exclamation-triangle text-warning'></i> - {HtmlParser(globalSettings?.messages?.registerNewUserTittle01?.[languageObj?.id])}.</h5>

            <div className='callout callout-warning'>
                <p style={styles?.paragrapJustify}>
                    {HtmlParser(msgText)}
                </p>
            </div>

            <div>
                <p>
                    {/* <i className={globalSettings?.icons?.userClock}></i><Link to={globalSettings?.app?.backend?.urlRegisterStatus}>{' '}{globalSettings?.labels?.checkRegistrationStatus}</Link> */}
                    <i className={globalSettings?.icons?.userClock}></i>
                    <a href={globalSettings?.app?.backend?.urlRegisterStatus}>
                        {' '}{globalSettings?.labels?.checkRegistrationStatus?.[languageObj?.id]}
                    </a>
                </p>
                <p>
                    {/* <Link to={globalSettings?.app?.backend?.urlHome} className='btn btn-outline-primary'><i className={globalSettings?.icons?.home}></i></Link> */}
                    <a href={globalSettings?.app?.backend?.urlHome} className='btn btn-outline-primary'>
                        <i className={globalSettings?.icons?.home}></i>
                    </a>
                </p>
            </div>
        </div>
    )
}